export const APP_LAUNCHED = 'APP_LAUNCHED'

export const OEP_DETECTED = 'OEP_DETECTED'

export const SAVE_PROGRESS_DIALOG_OPENED = 'SAVE_PROGRESS_DIALOG_OPENED'
export const SAVE_PROGRESS_DIALOG_CLOSED = 'SAVE_PROGRESS_DIALOG_CLOSED'

export const AUTHENTICATED_SUCCESSFULY = 'AUTHENTICATED_SUCCESSFULY'

export const WELCOME_BACK_REQUESTED = 'WELCOME_BACK_REQUESTED'
export const WELCOME_BACK_RECEIVED = 'WELCOME_BACK_RECEIVED'
export const WELCOME_BACK_FAILED = 'WELCOME_BACK_FAILED'

export const SYSTEM_ERROR_MODAL_CLOSED = 'SYSTEM_ERROR_MODAL_CLOSED'

export const TIMEOUT_MODAL_OPENED = 'TIMEOUT_MODAL_OPENED'
export const TIMEOUT_MODAL_CLOSED = 'TIMEOUT_MODAL_CLOSED'
export const REFRESH_TOKEN_REQUESTED = 'REFRESH_TOKEN_REQUESTED'
export const REFRESH_TOKEN_RECEIVED = 'REFRESH_TOKEN_RECEIVED'
export const TOKEN_EXPIRY_UPDATED = 'TOKEN_EXPIRY_UPDATED'
export const USER_INTERACTED = 'USER_INTERACTED'

export const LOGOUT_REQUESTED = 'LOGOUT_REQUESTED'
export const LOGOUT_RECEIVED = 'LOGOUT_RECEIVED'

export const APPLICATION_RELOADED = 'APPLICATION_RELOADED'
export const APP_CONFIG_REQUESTED = 'APP_CONFIG_REQUESTED'
export const APP_CONFIG_RECEIVED = 'APP_CONFIG_RECEIVED'

export const TOKEN_DETECTED = 'TOKEN_DETECTED'

export const SAVE_DIALOG_OPEN_CLICKED = 'SAVE_DIALOG_OPEN_CLICKED'
export const SAVE_DIALOG_OPENED = 'SAVE_DIALOG_OPENED'
export const APPLICATION_VALIDATED = 'APPLICATION_VALIDATED'

export const SHARE_APPLICATION_DIALOG_OPENED = 'SHARE_APPLICATION_DIALOG_OPENED'
export const SHARE_APPLICATION_DIALOG_CLOSED = 'SHARE_APPLICATION_DIALOG_CLOSED'

export const SHARE_QUOTE_DIALOG_OPENED = 'SHARE_QUOTE_DIALOG_OPENED'
export const SHARE_QUOTE_DIALOG_CLOSED = 'SHARE_QUOTE_DIALOG_CLOSED'

export const BROKER_TIMEOUT_MODAL_OPENED = 'BROKER_TIMEOUT_MODAL_OPENED'
export const BROKER_TIMEOUT_MODAL_CLOSED = 'BROKER_TIMEOUT_MODAL_CLOSED'

export const LAYOUT_APPLIED = 'LAYOUT_APPLIED'

export const BROKER_WELCOME_BACK_REQUESTED = 'BROKER_WELCOME_BACK_REQUESTED'
export const BROKER_WELCOME_BACK_RECEIVED = 'BROKER_WELCOME_BACK_RECEIVED'

export const BROKER_DATA_UPDATED = 'BROKER_DATA_UPDATED'

export const NAVIGATED_HOME = 'NAVIGATED_HOME'

export const UNAUTHORIZED_MODAL_OPENED = 'UNAUTHORIZED_MODAL_OPENED'